module.exports = new __parcel__URL__("right_section_bg_dark.dc17e2a1.svg").toString();